const ACTION_TYPES = {
    ROUTE_TO_ADMIN: 'Route To Admin',
    SEND_QUOTE_TO_ACTIVATE: 'Create New Quote',
    SAVE_TO_BOX: 'Save to Box',
    CHANGE_DUE_DATE: 'Change Due Date',
    UPLOAD_POD: 'Upload POD',
    QUOTE_WON: 'Quote Won',
    QUOTE_LOST: 'Quote Lost',
    FORWARD_TO_APPRAISER: 'Forward to Appraiser',
    PROPERTY_CONTACT_REQUEST: 'Property Contact Request',
    PROPERTY_CONTACT_FOLLOW_UP: 'Property Contact Follow Up',
    CLIENT_INTRODUCTION: 'Client Introduction',
    CLIENT_FOLLOW_UP: 'Client Follow Up'
};

const BOX_FOLDER_NAMES = {
    DEFAULT_SELECTED_FOLDER: '',
};

export {
    ACTION_TYPES,
    BOX_FOLDER_NAMES
};

